import { Table } from "reactstrap";
import './Globals.css'
import { useDispatch } from "react-redux";
import { getIECFormDataAPICall } from "../api/iecAcitivityAPI";
import { handleUpdatePageSlice } from "../redux/slices/globalSlice";

const TableComponent = ({ data, tableHeadersList }: any) => {
    const dispatch: any = useDispatch();
    const handleViewForm = (iecId: string) => {
        dispatch(getIECFormDataAPICall(iecId));
        dispatch(handleUpdatePageSlice(true))
    }

    const keys = data.data?.length > 0 ? Object.keys(data.data[0]) : [];
    return (
        <div style={{ paddingBottom: '40px' }}>
            <Table striped hover bordered responsive className="icv-table">
                <thead>
                    <tr className="align-center">
                        {tableHeadersList.map((key: any) => (
                            <th key={key} className={key === "IEC ID" ? "sticky-left" : ''}>{key}</th>
                        ))}
                    </tr>
                </thead>
                {data?.statusCode === 1 ? <tbody>
                    {data?.data?.map((row: any, rowIndex: any) => (
                        <tr key={rowIndex}>
                            {keys.map((key) => {
                                return (
                                    <td 
                                        key={key}
                                        className={key === "iecId" ? "view-form sticky-left p-2" : 'p-2'}
                                        onClick={() => {key === "iecId" && handleViewForm(row.iecId ?? '')}}
                                    >{
                                        row[key] === row.iecDate ? row.iecDate.split("T")[0].split("-").reverse().join("-") : row[key] ?? '--'
                                    }</td>
                                )
                            })}
                        </tr>
                    ))}
                </tbody> : ""}
            </Table>
        </div>
    );
};
export default TableComponent;